import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Spinner from "react-bootstrap/Spinner";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import IndicatorsList from "../Components/IndicatorsList";
import TeamMemberList from "../Components/TeamMemberList";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./MyIndicators.css";

function MyIndicators() {
  const [isLoading, setIsLoading] = useState(true);
  const [indicators, setIndicators] = useState([]);
  const [teamMembers, setTeamMembers] = useState([]);
  const [invited, setInvited] = useState([]);

  const { state } = useContext(AuthContext);

  const [key, setKey] = useState("MyIndicators");

  const { t } = useTranslation();

  const location = useLocation();

  const tabKey = location.state?.tabKey;

  const currentUser = location.state?.currentUser;

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "post",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/user/${state.userId}`,
        data: {
          status: "active",
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setIndicators(response.data.indicators);
      setTeamMembers(response.data.teamMembers);
      setInvited(response.data.invited);
      setKey(tabKey);
      setIsLoading(false);
      document
        .getElementById(`${currentUser}`)
        ?.scrollIntoView({ behavior: "smooth" });
    }
    fetch();
  }, [state.token, state.userId, tabKey, currentUser]);

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <Row className="align-items-center">
          <Col lg={11} className="indicators-header">
            <h2>{t("Indicadores.MisIndicadores.Titulo")}</h2>
          </Col>
          <Col lg={1} className="right indicators-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/indicators/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Indicadores.NuevoIndicador")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row>
          <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3">
            <Tab
              eventKey="MyIndicators"
              title={t("Indicadores.MisIndicadores.Titulo")}
            >
              <Row>
                {indicators.length === 0 ? (
                  <Col className="empty-indicators center">
                    <h5>{t("Indicadores.SinIndicadores")}</h5>
                  </Col>
                ) : (
                  <IndicatorsList
                    indicators={indicators}
                    language={state.language}
                  />
                )}
              </Row>
            </Tab>
            <Tab eventKey="MyTeam" title={t("Indicadores.MiEquipo")}>
              <Row>
                {teamMembers.length === 0 ? (
                  <Col className="empty-indicators center">
                    <h5>{t("Indicadores.SinIndicadores")}</h5>
                  </Col>
                ) : (
                  <TeamMemberList
                    teamMembers={teamMembers}
                    language={state.language}
                  />
                )}
              </Row>
            </Tab>
            <Tab eventKey="Invited" title={t("Indicadores.Invitado")}>
              <Row>
                {invited.length === 0 ? (
                  <Col className="empty-indicators center">
                    <h5>{t("Indicadores.SinIndicadores")}</h5>
                  </Col>
                ) : (
                  <TeamMemberList
                    teamMembers={invited}
                    language={state.language}
                  />
                )}
              </Row>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    );
  }
}

export default MyIndicators;
